export var getImageUrl = function (image, size) {
    if (size === void 0) { size = "medium"; }
    if (image && image.large) {
        size = "large";
    }
    return image && image[size]
        ? image[size]
        : "https://storage.googleapis.com/c91b2bb74b7db747a90a1741add6745f/needle_images/app/fallback.svg";
};
